import { render, staticRenderFns } from "./VAppLocale.vue?vue&type=template&id=2b368792&scoped=true&"
import script from "./VAppLocale.vue?vue&type=script&lang=js&"
export * from "./VAppLocale.vue?vue&type=script&lang=js&"
import style0 from "./VAppLocale.vue?vue&type=style&index=0&id=2b368792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b368792",
  null
  
)

export default component.exports